export default "__VITE_ASSET__AGv6bBS8__"